import React from 'react'
import PropTypes from 'prop-types'
import { FilterFacet } from './FilterGroup.styles'
import FilterOption from './FilterOption'
import FilterGroupToggle from './FilterGroupToggle'

const FilterGroupField = ({
  className,
  expandable,
  expanded,
  name,
  onChange,
  options,
  selectedCheckboxes = [],
  title,
  toggleHandlers
}) =>
  <FilterFacet className={ className } title={ title }>
    {
      options.map(({ navigationState, ...data }, index) =>
        <FilterOption
          key={ `${navigationState}-${index}` }
          { ...data }
          navigationState={ navigationState }
          selected={ selectedCheckboxes.includes(navigationState) }
          onSelect={ onChange } />
      )
    }
    {
      expandable &&
        <FilterGroupToggle expanded={ expanded } toggleHandlers={ toggleHandlers } />
    }
  </FilterFacet>

export default FilterGroupField

FilterGroupField.propTypes = {
  className: PropTypes.string,
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  selectedCheckboxes: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  })
}
